import React, {FC, useEffect} from 'react';

import {useMentionMe} from './hooks/useMentionMe';
import {PropsMentionType} from './mentionMeTypes';

/**
 * Component display pixel received from MentionMe
 * @param {PropsMentionType} prop - prop type
 * @return {JSX.Element | null} - jsx element
 */
export const MentionMe: FC<PropsMentionType> = ({classes = '', integratingType, params}) => {
    const {generateScript, isCookieAvailable, isFulfilled, shouldHide} = useMentionMe(
        params,
        integratingType,
    );

    /**
     * After rendering the component, get and embed the pixel received from MentionMe
     */
    useEffect(() => {
        generateScript();
    }, [isCookieAvailable, isFulfilled]);

    if (shouldHide) return null;

    return <div className={classes} data-testid="mmWrapper" id="mmWrapper" role="presentation" />;
};
